// utils/text.js

export function countWords(str = "") {
  return str.trim().split(/\s+/).filter(Boolean).length;
}

export function countChars(str = "") {
  return str.length;
}
